import { useButtonPressedCallback } from '@zenbusiness/application-commons-clickstream';
import Checkbox from '@zenbusiness/zui/Checkbox';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { FormControlLabelStyled } from './components/Own75OrMoreUIField.styles';

export const Own75OrMoreUIField = ({
  field = { setSaved: () => {}, setLoading: () => {} },
  value = false,
  dataChangeHandler = () => {},
  disabled
}) => {
  const trackOwn750ChangeClick = useButtonPressedCallback({
    elementText: '75_ownership_checkbox',
    elementName: 'banking_collect_info',
    appPageName: 'banking_application'
  });
  const onDataChanged = (_, checked) => {
    if (checked) {
      field.setLoading();
    }

    dataChangeHandler(
      checked,
      { bankAccountMembers: [{ ownsSeventyFiveOrMore: checked }] },
      (forceUpdate, { isSave, isError }) => {
        field.setSaved(isSave, isError, checked);
        forceUpdate();
      }
    );
    /**
     * Tracking Details: Tracking to be added to the banking application Collect Info screen.
     * Question:
     *          Where are customers typically dropping off on this screen?
     *          Do they typically drop off at SSN?
     *          How often are they viewing the user agreements?
     */
    trackOwn750ChangeClick();
  };

  return (
    <FormControlLabelStyled
      control={
        <Checkbox
          color="default"
          defaultChecked={value}
          disabled={disabled}
          id="ownsSeventyFiveOrMore"
          onChange={onDataChanged}
        />
      }
      label={<Text size="xl">Yes, I own 75% or more of this business</Text>}
    />
  );
};

Own75OrMoreUIField.propTypes = {
  value: PropTypes.bool,
  dataChangeHandler: PropTypes.func,
  field: PropTypes.shape({ setSaved: PropTypes.func, setLoading: PropTypes.func }),
  disabled: PropTypes.bool
};
